import React, { ReactNode } from "react"
import { Stack } from "@chakra-ui/react"
import ContainedForm from "components/ReactHookForm/ContainedForm"
import { useCurrentEvent } from "queries/events"
import Checkbox from "components/ReactHookForm/Checkbox"
import PageContent from "components/layout/PageContent"
import PublicTitleRow from "components/settings/PublicTitleRow"
import TitleWithSubtitle from "../TitleWithSubtitle"

type Props = {
  updateEvent: (params: {}) => Promise<void>
  children?: ReactNode
}

const Confirmations = ({ updateEvent, children }: Props) => {
  const { data: currentEvent } = useCurrentEvent()

  return (
    <PageContent noPadding>
      <TitleWithSubtitle
        title="Guest Confirmations"
        subtitle="Choose what appears on guest confirmations, both on the confirmation page and in confirmation emails."
      />
      <ContainedForm values={currentEvent} onSubmit={updateEvent} name="Guest Confirmations">
        {({ control }) => (
          <Stack spacing={8} py={2}>
            <PublicTitleRow
              label="Public Event Title"
              variant="outline"
              inputMaxW="none"
              value={currentEvent.publicEventTitle ?? ""}
              updateEvent={updateEvent}
              mb={0}
            />
            <Checkbox
              name="attachIcs"
              control={control}
              label="Include calendar invite and Add to Calendar buttons"
              leftLabel="Calendar Invite"
              mb={0}
            />
            <Checkbox
              name="includeSeatingInfo"
              control={control}
              label="Show table name and seat number"
              leftLabel="Seating Info"
              mb={0}
            />
            <Checkbox
              name="includeQrCode"
              control={control}
              label="Include QR code"
              leftLabel="QR Code"
              mb={0}
            />
            <Checkbox
              name="includePassbook"
              control={control}
              label="Include Add to Apple Wallet / Google Wallet buttons"
              leftLabel="Wallet Pass"
              mb={0}
            />
          </Stack>
        )}
      </ContainedForm>
      {children}
    </PageContent>
  )
}

export default Confirmations
